// State Machine Types - Simplified Application State Machine
// ✅ NO MAGIC STRINGS: Use enums/constants for all state and event names

export enum AppState {
  INITIALIZATION = "initialization",
  RECOVERY = "recovery",
  AUTHENTICATION = "authentication",
  WORKSPACE = "workspace",
  ERROR = "error",
}

export enum StateEvent {
  // Initialization events
  APP_START = "app_start",
  INITIALIZATION_COMPLETE = "initialization_complete",
  INITIALIZATION_FAILED = "initialization_failed",

  // Recovery events
  RECOVERY_START = "recovery_start",
  AUTH_CHECK_COMPLETE = "auth_check_complete",
  AUTH_DATA_MISSING = "auth_data_missing",
  SESSION_HAS_ORG = "session_has_org",
  SESSION_NO_ORG = "session_no_org",

  // Authentication events (login + org selection)
  AUTH_START = "auth_start",
  LOGIN_AND_ORG_SELECTED = "login_and_org_selected",
  LOGIN_FAILED = "login_failed",
  LOGOUT = "logout",

  // Workspace events
  WORKSPACE_ENTER = "workspace_enter",
  WORKSPACE_EXIT = "workspace_exit",
  ORG_SWITCHED = "org_switched",

  // Error handling events
  ERROR_OCCURRED = "error_occurred",
  RECOVER_FROM_ERROR = "recover_from_error",
  APP_EXIT = "app_exit",
}

export interface StateTransition {
  from: AppState;
  event: StateEvent;
  to: AppState;
}

export interface StateDataRequirements {
  requiredModules: string[];
  requiredData: string[];
  optionalData?: string[];
}

export interface StateAllowedRoutes {
  routes: string[];
  redirectTo?: string;
}

export interface AppPhase {
  state: AppState;
  dataRequirements: StateDataRequirements;
  allowedRoutes: StateAllowedRoutes;
  description: string;
}

export interface StateMachineConfig {
  initialState: AppState;
  transitions: StateTransition[];
  phases: AppPhase[];
  onTransition?: (from: AppState, to: AppState, event: StateEvent) => void;
}

export interface StateMachineContract {
  getState(): AppState;
  canTransition(event: StateEvent): boolean;
  transition(event: StateEvent): void;
  getAvailableEvents(): StateEvent[];
  getCurrentPhase(): AppPhase | null;
  getDataRequirements(): StateDataRequirements | null;
  getAllowedRoutes(): StateAllowedRoutes | null;
  reset(): void;
}
